import { z } from "zod";
import { ITEM_LIST, CITY_LIST } from "./dataIndex";

/**
 * Remotion Studio のサイドバーに品目ドロップダウンと都市選択を表示する
 * Zod スキーマ。
 *
 * z.enum() は [string, ...string[]] を要求するためキャストが必要。
 */
const itemEnum = z.enum(ITEM_LIST as unknown as [string, ...string[]]);
const cityEnum = z.enum(CITY_LIST as unknown as [string, ...string[]]);

export const surveyVideoSchema = z.object({
  /** X 軸に表示する品目 */
  itemX: itemEnum.describe("品目 X軸"),
  /** Y 軸に表示する品目 */
  itemY: itemEnum.describe("品目 Y軸"),
  /** 表示する都市（空配列＝全都市） */
  cities: z.array(cityEnum).describe("都市（空=全都市）"),
  /** 外れ値ラベル表示の閾値 (σ)。0 で全都市ラベル表示 */
  outlierSigma: z.number().min(0).step(0.1).describe("外れ値閾値 (σ)"),
});

export type SurveyVideoProps = z.infer<typeof surveyVideoSchema>;

/** Remotion Studio で初期表示されるデフォルト Props */
export const defaultProps: SurveyVideoProps = {
  itemX: "コーヒー",
  itemY: "緑茶",
  cities: [],
  outlierSigma: 3,
};
